var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.41309 4.50009C6.44819 3.71226 6.79211 2.96993 7.3704 2.43375C7.94869 1.89757 8.71485 1.61065 9.50309 1.63509H12.7506C13.5439 1.60256 14.3178 1.88584 14.9026 2.42287C15.4874 2.9599 15.8355 3.70687 15.8706 4.50009V13.5001C15.8375 14.2946 15.4902 15.0435 14.9052 15.5822C14.3201 16.1208 13.5452 16.4051 12.7506 16.3726H9.50309C8.71361 16.397 7.94636 16.109 7.36786 15.5713C6.78935 15.0335 6.44628 14.2893 6.41309 13.5001V4.50009Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4829 8.43764H4.05036L5.28786 7.20764C5.3932 7.10218 5.45237 6.95921 5.45237 6.81014C5.45237 6.66108 5.3932 6.51811 5.28786 6.41265C5.23628 6.36072 5.17493 6.3195 5.10736 6.29138C5.03978 6.26326 4.96731 6.24878 4.89411 6.24878C4.82092 6.24878 4.74845 6.26326 4.68087 6.29138C4.61329 6.3195 4.55195 6.36072 4.50036 6.41265L2.29536 8.60265C2.19003 8.70811 2.13086 8.85108 2.13086 9.00014C2.13086 9.14921 2.19003 9.29218 2.29536 9.39764L4.50036 11.5876C4.55204 11.6406 4.6139 11.6825 4.68222 11.7108C4.75054 11.7392 4.8239 11.7534 4.89786 11.7526C4.97177 11.753 5.045 11.7386 5.11326 11.7102C5.18152 11.6819 5.24343 11.6402 5.29536 11.5876C5.4007 11.4822 5.45987 11.3392 5.45987 11.1901C5.45987 11.0411 5.4007 10.8981 5.29536 10.7926L4.05036 9.56264H11.4829C11.632 9.56264 11.7751 9.50338 11.8806 9.39789C11.9861 9.2924 12.0454 9.14933 12.0454 9.00014C12.0454 8.85096 11.9861 8.70789 11.8806 8.6024C11.7751 8.49691 11.632 8.43764 11.4829 8.43764Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitGray);
export default __webpack_public_path__ + "static/media/exit-gray.557ba3b678f5c0421eddbe265b051a59.svg";
export { ForwardRef as ReactComponent };